import { LayerType } from '@app/core/shared/enums/field-view-layer.types';
import { BaseResponseDto } from '@models/base-response-dto';
import { MaterialSymbol } from 'material-symbols';
import { PopoutWindowKey } from '../utilities/popout.window.utlity';

export type MapViewProjectionFromData = {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
  projectionZone: string;
  proj4Value: string;
};

export interface FieldViewRouteData extends BaseResponseDto, FieldViewBase {
  pipelineRouteDataId: number;
  pipelineSurveyId: number;
  sourceTimestamp: Date;
}

export type FieldViewRouteDataRequest = {
  min?: number;
  max?: number;
  pipelineId: number;
};

export type FieldViewSurveyMenuData = {
  pipelineSurveyId: number;
  surveyYear: number;
  surveyIdent: string;
  title: string;
  totalEvents: number;
  totalBathy: number;
  bathyColor?: string;
  eventsColor?: string;
  eventIsChecked?: boolean;
  bathyIsChecked?: boolean;
  accordionIsExanded?: boolean;
};

export type FieldViewBathyData = {
  pipelineSurveyId: number;
  pipelineId: number;
  easting: number;
  northing: number;
};

export interface FieldViewEventData extends FieldViewBathyData {
  pipelineEventDataId: number;
  shapeType: string;
  shapeColour: string;
  shapeId: number;
  anomalyId: number;
}

export interface SelectedSurveyMenu extends FieldViewSurveyMenuData {
  layerType: LayerType;
  checked: boolean;
}

type FieldViewBase = {
  kp: number;
  easting: number;
  northing: number;
  depth: number;
};

export type FieldViewBathyBaseMapLayer = {
  year: number;
  layer: string;
};

export type FieldViewOpenWeatherBaseMapLayer = {
  formLabel: string;
  layer: string;
};

export type KpFeatureMeta = {
  start: number[];
  end: number[];
  kpFrom: number;
  kpTo: number;
  label: string;
};

export type KpActionState = {
  clickedKpIndex: number;
  totalKPFeatures: number;
  navigation: 'prev' | 'next' | 'first' | '';
};

export type FieldViewPopoutWindow = {
  id: PopoutWindowKey;
  tooltip: string;
  icon: MaterialSymbol;
};

export const ChartIDs = {
  SITE_ANOMALY_BREAKDOWN_CHART: 'siteAnomalyBreakdownChart',
  DEPTH_PROFILE_CHART: 'depthProfileChart',
  CP_PROFILE_CHART: 'cpProfileChart',
  EVENT_BREAKDOWN_CHART: 'eventBreakdownChart'
};

export type ChartID = (typeof ChartIDs)[keyof typeof ChartIDs];
